import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiService } from './admin/api.service';

export interface PatientLookupResult {
  success: boolean;
  found?: boolean;
  pending?: boolean;
  /** True when this mobile is used by other patients (e.g. family) */
  shared_contact?: boolean;
  others_on_number?: { patient_number: string; display_name: string }[];
  message: string;
  patients?: { patient_number: string; display_name: string }[];
}

export interface PendingRegistrationPayload {
  first_name: string;
  middle_name?: string;
  last_name: string;
  primary_contact: string;
  age: number;
  gender: string;
  blood_group?: string;
  address?: string;
  city?: string;
  state?: string;
  pincode?: string;
  country?: string;
  clinic_id?: number;
  website?: string;
}

@Injectable({ providedIn: 'root' })
export class PublicPatientRegistrationService {
  private baseUrl: string;

  constructor(private http: HttpClient, apiService: ApiService) {
    this.baseUrl = apiService.getBaseUrl();
  }

  lookup(payload: { first_name: string; last_name: string; primary_contact: string; website?: string }) {
    return this.http.post<PatientLookupResult>(
      `${this.baseUrl}/public/patient-registration/lookup`,
      payload
    );
  }

  submit(payload: PendingRegistrationPayload) {
    return this.http.post<{ success: boolean; message: string; data?: { reference_id: number } }>(
      `${this.baseUrl}/public/patient-registration`,
      payload
    );
  }
}
